import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

interface Props {
  title: string;
  onOpenMobileNav: () => void;
  isDesktop: boolean;
}

/**
 * TopBar — persistent application bar at the top of the ProductionShell.
 *
 * Renders:
 *   - Mobile hamburger (small screens only) → opens temporary drawer
 *   - Page title (driven by active productionRoute)
 *   - `P15` press chip in Abaris orange (#CB6015 — reserved accent)
 *   - An empty `next24h-slot` Box — populated by plan 09-09 with the
 *     "Next 24h locked" badge once the ritual/lock logic lands.
 */
export default function TopBar({ title, onOpenMobileNav, isDesktop }: Props) {
  return (
    <AppBar position="static" color="inherit" elevation={1} data-testid="production-topbar">
      <Toolbar sx={{ gap: 2 }}>
        {!isDesktop && (
          <IconButton edge="start" onClick={onOpenMobileNav} aria-label="Open navigation">
            <MenuIcon />
          </IconButton>
        )}
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, flexGrow: 1 }}
          data-testid="topbar-title"
        >
          {title}
        </Typography>
        <Chip
          label="P15 + P11"
          sx={{ bgcolor: '#CB6015', color: '#FFFFFF', fontWeight: 600 }}
          data-testid="press-chip"
        />
        <Box data-testid="next24h-slot" />
      </Toolbar>
    </AppBar>
  );
}
